export default __webpack_public_path__ + "static/media/learose4-1024w.7dc1cef2.avif";